import ReactSVGCore from 'react-svg';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const ReactSVG = lib.styled(ReactSVGCore)`
    font-size: 15px !important;

    svg > path {
      fill: ${(props: { selected: boolean }) =>
        props.selected ? colors.green05 : colors.lightBlue03};
    }

    div {
        display: flex;
        height: fit-content;
    }
`;
